export default {
  alert: {
    color: null,
    message: null,
    show: false,
    error: false
  },
  loading: true,
  showUpdateBanner: false
}
